import classnames from "classnames";
import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Dropdown } from "@components/General/Dropdown/dropdown.component";
import { DropdownItem } from "@components/General/Dropdown/dropdownItem.component";
import { Label } from "@components/General/Form/label.component";
import { Col } from "@components/General/Grid/col.component";

import "./calculationDropDownField.scss";

type Props = {
    name: string;
    dimension: string;
    setCalculationValue: (name: string, value: string) => void;
    value?: any | undefined;
    values: Array<{ value: string; label: string }>;
    sm?: number;
    md?: number;
    lg?: number;
    classNames?: string;
};

const CalculationDropDownField = ({
    name,
    dimension,
    values,
    setCalculationValue,
    value,
    sm,
    md,
    lg,
    classNames,
}: Props) => {
    const { t } = useGranite();

    return (
        <Col sm={sm} md={md} lg={lg} className={classnames("mt-3", classNames)}>
            <Label for={name}>{t(`calculator.${dimension}`)}</Label>
            <Dropdown
                placeholder={
                    values.find(v => v.value === value)?.label ||
                    values.at(0)?.label ||
                    ""
                }
            >
                {values.map(({ value, label }) => (
                    <DropdownItem
                        key={`${name}.${value}`}
                        onClick={() => setCalculationValue(name, value)}
                        label={label}
                    ></DropdownItem>
                ))}
            </Dropdown>
        </Col>
    );
};

export default CalculationDropDownField;
